import { functions } from "utils/firebase";

export const getSubscriptionStats = async (from, to) => {
	try {
		const getSubscriptionStats = functions.httpsCallable("getSubscriptionStats");
		const result = await getSubscriptionStats({ from, to });
		return result.data;
	} catch (error) {
		console.error("Error fetching subscription stats:", error);
		throw error;
	}
};
